import { v4 as uuidv4 } from 'uuid'
import { unifyParams } from '../../../utils/unifyParams'
import apinode from '../../apinode'

class WmsInventarioService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAddresses(productsSku) {
    const url = unifyParams(`/wms-inventario/addresses/${this.idconta}`, [
      {
        key: 'products',
        value: JSON.stringify(productsSku),
      },
    ])

    const response = await apinode.get(url)

    const responseFormatted = response.data.map((address) => ({
      id: uuidv4(),
      ...address,
    }))

    return responseFormatted
  }

  async getAll() {
    const response = await apinode.get(`/wms-inventario/${this.idconta}`)

    return response.data
  }

  async getById(id) {
    const response = await apinode.get(`/wms-inventario/${id}/${this.idconta}`)

    return response.data
  }

  async create(config) {
    const data = {
      ...config,
      usuario_id: localStorage.idusuario,
    }

    const response = await apinode.post(`/wms-inventario/${this.idconta}`, data)

    return response.data.id
  }

  async generateBreak({
    enderecos,
    tipo_quebra,
    dividir_picking_pulmao,
    quantidade_maxima_predios,
    inventario_id,
  }) {
    const response = await apinode.post(
      `/wms-inventario/generate-break/${this.idconta}`,
      {
        enderecos,
        tipo_quebra,
        dividir_picking_pulmao,
        quantidade_maxima_predios,
        inventario_id,
      },
    )

    return response.data.message
  }

  async delete(id) {
    await apinode.delete(`/wms-inventario/${id}/${this.idconta}`)
  }
}

export default new WmsInventarioService()
